import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConcurrencyCheckResponse } from '../shared/models/concurrency-check-response-model';
import { ContextService } from './context.service';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class BsCallApiService {

  constructor(
    private http: HttpClient,
    private sessionService: SessionService,
    private contextService: ContextService
  ) {}

  public concurrencyCheck(refreshToken: string): Observable<ConcurrencyCheckResponse> {
        let endpoint;
        if (this.contextService.isExecutiveMode()) {
            endpoint = `${environment.REFRESH_URL.OMNI2}
            ${environment.bankingServer.base_path.omni2}
            ${environment.bankingServer.concurrencyCheck}`;
        } else {
            endpoint = `${environment.REFRESH_URL.OMNI1}
            ${environment.bankingServer.base_path.omni1}
            ${environment.bankingServer.concurrencyCheck}`;
        }

        this.sessionService.dateLastUpdate = Math.round(new Date().getTime() / 1000);

        return this.http.get<ConcurrencyCheckResponse>(`${endpoint}${refreshToken}`);
    }
}
